import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [settings, setSettings] = useState({ whatsapp: "", phone: "", email: "", address: "" });
  const [user, setUser] = useState(null);

  const loadSettings = useCallback(() => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}), []);

  useEffect(() => {
    loadSettings();
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, [loadSettings]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fv_token", data.token);
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("fv_token");
    setUser(false);
  };

  return (
    <Ctx.Provider value={{ settings, setSettings, loadSettings, user, login, logout }}>{children}</Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
